import React, { useState } from "react";
import { Box, Card, Switch, TextField, FormControl, InputLabel, Select, MenuItem, Button, FormControlLabel } from "@mui/material";
import { useAdminPanelContext } from "../../context/AdminPanelContext";
import { ScraperConfig } from "./types";

export interface NewConfigFormProps {
  config: ScraperConfig;
}

const NewConfigForm: React.FC<NewConfigFormProps> = ({ config }) => {
  const { scrapers, handleConfigs } = useAdminPanelContext();
  const [updatedConfig, setUpdatedConfig] = useState<ScraperConfig>({ ...config });

  const handleSelectScraper = (e) => {
    setUpdatedConfig({ ...updatedConfig, scraper: scrapers.find((s) => s.id === e.target.value) });
  };

  return (
    <>
      {config ? (
        <Card sx={{ padding: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <FormControl fullWidth>
              <TextField
                label="Name"
                onChange={(e) => setUpdatedConfig({ ...updatedConfig, name: e.target.value })}
                value={updatedConfig.name}
              />
            </FormControl>
            <FormControl fullWidth sx={{ marginLeft: 2 }}>
              <InputLabel>Scraper</InputLabel>
              <Select label="Scraper" value={updatedConfig?.scraper?.id || ""} onChange={handleSelectScraper}>
                {scrapers.map((s) => {
                  return (
                    <MenuItem key={s.id} value={s.id}>
                      {s.type} - {s.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControlLabel
              value="Active"
              control={
                <Switch
                  color="success"
                  checked={updatedConfig?.active}
                  onChange={(e) => setUpdatedConfig({ ...updatedConfig, active: e.target.checked })}
                />
              }
              label="Active"
              labelPlacement="top"
            />
            <Button variant="outlined" sx={{ marginLeft: 2 }} onClick={() => handleConfigs.add(updatedConfig)}>
              Save
            </Button>
            <Button variant="outlined" color="error" sx={{ marginLeft: 2 }} onClick={() => handleConfigs.delete(config.id)}>
              Delete
            </Button>
          </Box>
        </Card>
      ) : null}
    </>
  );
};

export default NewConfigForm;
